import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isEdit: false,
    data: {}
};

const editSlice = createSlice({
    name: "edit",
    initialState,
    reducers: {
        AddToEdit: (state, action) => {
            state.isEdit = true;
            state.data = { ...action.payload };
        },
        EditDone: (state) => {
            state.isEdit = false
            state.data = {}
        },
    },
});

const editReducer = editSlice.reducer
export const { AddToEdit, EditDone } = editSlice.actions;
export default editReducer